import styled from 'styled-components';

export const ValidationErrorTxt = styled.span`
    color: var(--danger);
    font-size: 12px;
`;
